import { useResetSmartPreferences } from '@/src/hooks/srp/aiRecommendation'
import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import { DeviceType } from '@/src/types/deviceType'
import { TranslationFunction } from '@/src/types/translations'
import { Box, Button, Chip, Stack, Typography } from '@mui/material'
import React from 'react'

interface FilterHeaderProps {
    totalFlights: number
    numberOfFlightsAfterFilter: number
    tHeader: TranslationFunction<'header'>
    tCommon: TranslationFunction<'common'>
    deviceType: DeviceType
}

const FilterHeader = React.memo(
    ({ totalFlights, numberOfFlightsAfterFilter, tHeader, tCommon, deviceType }: FilterHeaderProps) => {
        const { isFilterApplied, appliedFilterList } = useClearFilters()
        const { resetAIStatesAndClearAllFiltersForCurrentLeg } = useResetSmartPreferences()
        return (
            <Box
                sx={{
                    px: 2,
                    py: 1.5,
                    borderBottom: 1,
                    borderColor: 'grey.200',
                    bgcolor: 'background.default',
                    position: deviceType === 'MOBILE' ? 'sticky' : 'static',
                    top: deviceType === 'MOBILE' ? 0 : 'auto',
                    zIndex: deviceType === 'MOBILE' ? 1 : 'auto'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: '#66797F' }}>
                    <Typography variant="body2" sx={{ color: 'grey.600' }}>
                        <Typography component="span" sx={{ fontWeight: 600 }}>
                            {numberOfFlightsAfterFilter}
                        </Typography>
                        <Typography component="span" sx={{ mx: 0.5 }}>
                            {tCommon('of')}
                        </Typography>
                        <Typography component="span" sx={{ fontWeight: 600 }}>
                            {totalFlights}
                        </Typography>
                        <Typography component="span" sx={{ mx: 0.5 }}>
                            {tHeader('flights')}
                        </Typography>
                    </Typography>
                    {isFilterApplied && (
                        <Box>
                            <Button variant="text" sx={{ fontWeight: 600 }} onClick={resetAIStatesAndClearAllFiltersForCurrentLeg}>
                                {tCommon('clearFilters')}
                            </Button>
                        </Box>
                    )}
                </Box>
                {isFilterApplied && deviceType === 'DESKTOP' && (
                    <Stack direction="row" flexWrap="wrap" sx={{ gap: 1, mt: 1 }}>
                        {appliedFilterList.map(chip =>
                            chip.show ? (
                                <Chip
                                    key={chip.label}
                                    color="primary"
                                    label={chip.label}
                                    variant="outlined"
                                    onDelete={chip.onDelete}
                                    onClick={chip.onDelete}
                                />
                            ) : null
                        )}
                    </Stack>
                )}
            </Box>
        )
    }
)

FilterHeader.displayName = 'FilterHeader'

export default FilterHeader
